// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export const ProductType =
{
    General: 0,
    Intraday: 1,
    Delivery: 2,
    CorporateAction: 4
}

ProductType.keys = (function ()
{
    let obj = {}
    for (let k in ProductType)
        obj[ProductType[k]] = k
    return obj
})()

export const ORDER_PARAMETER_PRODUCT_TYPE = 'productType';